import React from 'react';
import {
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
} from 'mdb-react-ui-kit';
import { Form } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';

const ImageViewModal = ({ showModal, setShowModal, renderLink, imgDoc, closeModal, title }) => {
  const { t } = useTranslation();

  return (
    <MDBModal tabIndex="-1" show={showModal} setShow={setShowModal}>
      <MDBModalDialog className="fixed inset-0  flex items-center justify-center z-50">
        <MDBModalContent className="bg-green-50   rounded-lg shadow-lg max-w-md w-full ">
          <Form>
            <MDBModalHeader className="mx-auto border-gray-300">
              <MDBModalTitle className={'text-customgreen relative left-[38%] right-[38%] font-semibold text-xl '}>
                {t('Image View')}
              </MDBModalTitle>
              <MDBBtn
                type="button"
                className="btn-close relative left-[-3%] right-[70%]"
                color="none"
                onClick={(e) => closeModal(e)}
              ></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              {renderLink != '' ? (
                <div className="container-fluid bd-example-row h-52">
                  <img src={`${renderLink ?? imgDoc?.doc}`} className="max-h-52 w-full" alt="img.jpg" />
                </div>
              ) : (
                <div className="container-fluid bd-example-row h-52">
                  <img src={`data:image/jpeg;base64,${imgDoc}`} className="max-h-52 w-full" alt="img.jpg" />
                </div>
              )}
            </MDBModalBody>
            {/* <MDBModalFooter className="flex justify-start">
              <button
                className="text-white  hover:text-white transition duration-700 ease-in-out bg-customgreen   hover:bg-hovergreen  font-medium rounded-full text-sm px-4 py-2 text-center me-2"
                onClick={() => setShowModal(false)}
                type="button"
              >
                {t('close')}
              </button>
            </MDBModalFooter> */}
          </Form>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  );
};

export default ImageViewModal;
